module.exports = __webpack_public_path__ + "static/media/designIcon.aa4a5a6d.svg";